import {createSlice} from "@reduxjs/toolkit";

export const invitesSlice = createSlice({
    name: "invites",
    initialState: {
        value: null,
        count: 0,
    },
    reducers: {
        setInvites: (state, action) => {
            state.value = action.payload;
            state.count = action.payload.length;
        },
    },
});

export const {setInvites} = invitesSlice.actions;

export const selectInvites = (state) => state.invitesList.value;

export default invitesSlice.reducer;

